export enum AppEntryRole {
  Undetermined,
  Keyer,
}

export class KeyerUserType {
  public readonly key = 'KeyerUserType';
  public readonly appEntryRole = AppEntryRole.Keyer;
}
